import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HeaderComponent } from './includes/header/header.component';
import { MenuComponent } from './includes/menu/menu.component';
import {} from '@angular/common/http';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    imports: [
        MenuComponent,
        NgxSpinnerModule,
        RouterOutlet
    ],
    styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {


  constructor(
    ){
    
  }

  link:any

  ngOnInit(): void {

  }
 
  
}
